<template>
  <v-flex class="internal-maintenance-table" xs12>
    <v-flex d-flex xs12 my-5>
      <div class="d-flex search">
        <v-text-field
          v-model="searchString"
          class="maintenance__search"
          solo
          hide-details
          :placeholder="$t('auto.fields.numberPlaceholder')"
        />
        <v-btn
          type="button"
          class="search-btn warning"
          depressed
          large
          @click="filters.search = searchString"
        >
          {{ $t('common.btns.search') }}
        </v-btn>
      </div>

      <v-select
        v-model="filters.carParks"
        item-value="id"
        item-text="name"
        class="internal-maintenance-table__filter"
        multiple
        clearable
        :items="parks"
        :label="$t('employees.park')"
        :loading="parksLoading"
      >
        <template #selection="{ index }">
          <template v-if="index > 0"></template>
          <template v-else>
            {{ filters.carParks.length }}
            {{ $t('common.selected') }}
          </template>
        </template>
      </v-select>
    </v-flex>

    <!-- <v-flex d-flex>
      <v-select
        v-model="filters.columns"
        class="internal-maintenance-table__filter"
        item-text="name"
        multiple
        clearable
        :label="$t('common.column')"
        :items="columnFilterItems"
        @change="onColumnsSelect"
      >
        <template #selection="{ index }">
          <span v-if="index === 0">
            {{ selectedColumns.length }} {{ $t('common.selected') }}
          </span>
        </template>
      </v-select>
      <v-select
        class="internal-maintenance-table__filter"
        item-text="text"
        item-value="value"
        :items="colorSelectItems"
        :disabled="!filters.columns.length"
        :label="$t('common.color')"
      />
    </v-flex> -->
    <v-data-table
      class="internal-maintenance-table__list"
      ref="maintenance-table"
      :height="tableHeight"
      :headers="headers"
      :items="list"
      :loading="loading"
      :items-per-page="perPage"
      hide-default-header
      hide-default-footer
    >
      <template #header="{ props }">
        <thead class="v-data-table-header">
          <tr>
            <template v-for="(header, key) in props.headers">
              <th
                v-show="!header.hidden"
                class="text-align-center"
                :class="{ section: header.sections }"
                :style="{ minWidth: header.width || 'auto' }"
                :key="`header-${key}`"
                :colspan="header.sections ? header.sections.length : 1"
              >
                <template v-if="header.sections">
                  {{ $t(header.text) }}
                </template>
              </th>
            </template>
          </tr>

          <tr>
            <template v-for="(header, key) in props.headers">
              <template v-if="header.sections">
                <th
                  v-for="(subheader, idx) in header.sections"
                  :key="`subheader-${key}-${idx}`"
                  class="section"
                  :class="{ last: idx === header.sections.length - 1 }"
                >
                  <div>{{ $t(subheader.text) }}</div>
                </th>
              </template>

              <th v-show="!header.hidden" :key="key" v-else>
                {{ $t(header.text) }}
              </th>
            </template>
          </tr>
        </thead>
      </template>

      <template #item="{ item }">
        <tr>
          <!-- Car -->
          <td>
            <div style="width:28px">{{ item.num }}</div>
          </td>
          <td>
            <div style="width:28px">{{ item.id }}</div>
          </td>
          <td>
            <div>{{ item.car.number }}</div>
          </td>
          <td>
            <div>{{ item.car.brand.name }}</div>
          </td>
          <td>
            <div>{{ item.car.model.name }}</div>
          </td>
          <td>
            <div>{{ item.car.year }}</div>
          </td>
          <td>
            <div>{{ item.car.park ? item.car.park.name : '—' }}</div>
          </td>
          <td>
            <div>{{ item.car.tachometer }}</div>
          </td>

          <!-- Options -->
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.oil_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'oil_change_date';
                }
              "
            >
              {{ item.oil_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.oil_change_next_days)">
            {{ item.oil_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.brake_pads_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'brake_pads_change_date';
                }
              "
            >
              {{ item.brake_pads_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.brake_pads_change_next_days)">
            {{ item.brake_pads_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.coolant_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'coolant_change_date';
                }
              "
            >
              {{ item.coolant_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.coolant_change_next_days)">
            {{ item.coolant_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.brake_fluid_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'brake_fluid_change_date';
                }
              "
            >
              {{ item.brake_fluid_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.brake_fluid_change_next_days)">
            {{ item.brake_fluid_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.air_filter_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'air_filter_change_date';
                }
              "
            >
              {{ item.air_filter_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.air_filter_change_next_days)">
            {{ item.air_filter_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue =
                    item.auto_transmission_oil_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'auto_transmission_oil_change_date';
                }
              "
            >
              {{ item.auto_transmission_oil_change_date || '—' }}
            </button>
          </td>
          <td
            :class="
              getExpireStateColor(item.auto_transmission_oil_change_next_days)
            "
          >
            {{ item.auto_transmission_oil_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue =
                    item.manual_transmission_oil_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'manual_transmission_oil_change_date';
                }
              "
            >
              {{ item.manual_transmission_oil_change_date || '—' }}
            </button>
          </td>
          <td
            :class="
              getExpireStateColor(item.manual_transmission_oil_change_next_days)
            "
          >
            {{ item.manual_transmission_oil_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.steering_oil_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'steering_oil_change_date';
                }
              "
            >
              {{ item.steering_oil_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.steering_oil_change_next_days)">
            {{ item.steering_oil_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.spark_plugs_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'spark_plugs_change_date';
                }
              "
            >
              {{ item.spark_plugs_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.spark_plugs_change_next_days)">
            {{ item.spark_plugs_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.fuel_filter_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'fuel_filter_change_date';
                }
              "
            >
              {{ item.fuel_filter_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.fuel_filter_change_next_days)">
            {{ item.fuel_filter_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.clutch_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'clutch_change_date';
                }
              "
            >
              {{ item.clutch_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.clutch_change_next_days)">
            {{ item.clutch_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.timing_belt_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'timing_belt_change_date';
                }
              "
            >
              {{ item.timing_belt_change_date || '—' }}
            </button>
          </td>
          <td :class="getExpireStateColor(item.timing_belt_change_next_days)">
            {{ item.timing_belt_change_next_date || '—' }}
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.battery_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'battery_change_date';
                }
              "
            >
              {{ item.battery_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.radiator_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'radiator_change_date';
                }
              "
            >
              {{ item.radiator_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.grenade_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'grenade_change_date';
                }
              "
            >
              {{ item.grenade_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.hub_bearing_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'hub_bearing_change_date';
                }
              "
            >
              {{ item.hub_bearing_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.fuel_pump_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'fuel_pump_change_date';
                }
              "
            >
              {{ item.fuel_pump_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.generator_belt_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'generator_belt_change_date';
                }
              "
            >
              {{ item.generator_belt_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.starter_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'starter_change_date';
                }
              "
            >
              {{ item.starter_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.tip_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'tip_change_date';
                }
              "
            >
              {{ item.tip_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue =
                    item.collapse_convergence_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'collapse_convergence_change_date';
                }
              "
            >
              {{ item.collapse_convergence_change_date || '—' }}
            </button>
          </td>
          <td>
            <button
              class="edit-btn"
              :disabled="editDisabled"
              @click="
                () => {
                  editDialog.opened = true;
                  editDialog.currentValue = item.barrel_antifreeze_change_date;
                  editDialog.itemId = item.id;
                  editDialog.paramName = 'barrel_antifreeze_change_date';
                }
              "
            >
              {{ item.barrel_antifreeze_change_date || '—' }}
            </button>
          </td>
        </tr>
      </template>

      <template #footer>
        <v-divider />
        <div class="pt-1 pb-2">
          <v-pagination
            color="warning"
            :value="currentPage"
            :length="lastPage"
            dark
            circle
            @input="fetchList({ ...filters, page: $event })"
          />
        </div>
      </template>
    </v-data-table>

    <v-snackbar v-model="snack.opened" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>

    <maintenance-date-dialog
      v-model="editDialog.opened"
      :current-value="editDialog.currentValue"
      :param-name="editDialog.paramName"
      :item-id="editDialog.itemId"
      @update="proccessResult"
    />
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';
import MaintenanceDateDialog from '@/components/auto/MaintenanceDateDialog.vue';
import calcTableHeight from '@/helpers/calcTableHeight';

export default {
  props: {
    investor: {
      type: Boolean,
      default: false,
    },
  },
  components: { MaintenanceDateDialog },
  data: () => ({
    loading: false,
    parksLoading: false,
    searchString: '',
    tableHeight: 'auto',

    filters: {
      search: '',
      carParks: [],
    },

    editDialog: {
      opened: false,
      currentValue: '',
      paramName: '',
      itemId: '',
    },

    snack: {
      opened: false,
      message: '',
      color: '',
    },
  }),
  watch: {
    filters: {
      immediate: true,
      deep: true,
      async handler(params) {
        this.fetchList(params);
      },
    },
  },
  computed: {
    ...mapState({
      list: ({ auto }) => auto.internalMaintenance.list,
      currentPage: ({ auto }) => auto.internalMaintenance.currentPage,
      lastPage: ({ auto }) => auto.internalMaintenance.lastPage,
      perPage: ({ auto }) => auto.internalMaintenance.perPage,
      parks: ({ parks }) => parks.list,
    }),
    headers() {
      return [
        { text: 'common.number', width: '60px' },
        { text: 'autosList.tableHeaders.id', width: '60px' },
        {
          text: 'common.fields.selectAuto',
          sections: [
            { text: 'auto.fields.number' },
            { text: 'auto.fields.brand' },
            { text: 'auto.fields.model' },
            { text: 'auto.fields.year' },
            { text: 'employees.park' },
            { text: 'auto.fields.tachometr' },
          ],
        },
        {
          text: 'auto.internalMaintenance.oilChange',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.brakeReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.coolantReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.brakeFluidReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.airFiltersReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.transmissionOilChange',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.manualTransmissionOilChange',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.steeringFluidReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.sparkPlugReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.fuelFilterReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.manualClutchReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.timingBeltReplacement',
          sections: [
            { text: 'auto.replacementDate' },
            { text: 'auto.nextReplacementDate' },
          ],
        },
        {
          text: 'auto.internalMaintenance.battery',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.radiator',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.grenade',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.hubBearing',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.fuelPump',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.generatorBelt',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.starter',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.tip',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.collapseConvergence',
          sections: [{ text: 'auto.replacementDate' }],
        },
        {
          text: 'auto.internalMaintenance.barrelAntifreeze',
          sections: [{ text: 'auto.replacementDate' }],
        },
      ];
    },
    columnFilterItems() {
      return [
        { name: this.$t('auto.internalMaintenance.oilChange') },
        { name: this.$t('auto.internalMaintenance.brakeReplacement') },
        { name: this.$t('auto.internalMaintenance.coolantReplacement') },
        { name: this.$t('auto.internalMaintenance.brakeFluidReplacement') },
        { name: this.$t('auto.internalMaintenance.airFiltersReplacement') },
        { name: this.$t('auto.internalMaintenance.transmissionOilChange') },
        { name: this.$t('auto.internalMaintenance.steeringFluidReplacement') },
        { name: this.$t('auto.internalMaintenance.sparkPlugReplacement') },
        { name: this.$t('auto.internalMaintenance.manualClutchReplacement') },
        { name: this.$t('auto.internalMaintenance.timingBeltReplacement') },
      ];
    },
    colorSelectItems() {
      return [
        { text: this.$t('common.green'), value: 'green' },
        { text: this.$t('common.yellow'), value: 'yellow' },
        { text: this.$t('common.red'), value: 'red' },
      ];
    },
    editDisabled() {
      return !this.$can('auto_internal_maintenance_edit') || this.investor;
    },
  },
  methods: {
    async fetchList(params) {
      this.loading = true;

      await this.$store.dispatch('auto/fetchInternalMaintenance', params);
      this.loading = false;
    },
    onColumnsSelect(value) {
      if (!value.length) this.filters.color = '';
    },
    proccessResult({ success }) {
      const snack = {
        opened: true,
        message: this.$t('common.saved'),
        color: 'success',
      };

      if (success) {
        this.fetchList({ ...this.filters, page: this.currentPage });
      } else {
        snack.message = this.$t('common.errors.APIerror');
        snack.color = 'error';
      }

      this.snack = snack;
    },
    getExpireStateColor(days) {
      if (days === null || days > 15) return '';

      if (days > 10) return 'green lighten-4';
      if (days > 0) return 'yellow lighten-4';

      return 'red lighten-4';
    },
  },
  async created() {
    this.parksLoading = true;
    await this.$store.dispatch('parks/fetchList');
    this.parksLoading = false;
  },
  mounted() {
    const table = this.$refs['maintenance-table'];
    this.tableHeight = calcTableHeight(table.$el);
  },
};
</script>

<style lang="scss">
.internal-maintenance-table {
  .search {
    max-width: 400px;
    width: 100%;
    margin-right: 50px;
  }

  &__list {
    margin-top: 10px;

    thead {
      position: sticky;
      top: 0;
      z-index: 2;

      tr {
        &:first-child th {
          position: sticky;

          &:first-child {
            left: 0px;
            z-index: 1;
          }

          &:nth-child(2) {
            left: 60px;
            z-index: 1;
          }

          &:nth-child(3) {
            left: 120px;
            z-index: 1;
            border-right: 2px solid #dddddd !important;
          }
        }

        &:nth-child(2) th {
          &:nth-child(-n + 7):not(:first-child) div {
            white-space: nowrap;
            width: 75px;
          }

          &:nth-child(1) {
            position: sticky;
            left: 0;
          }

          &:nth-child(2) {
            position: sticky;
            left: 60px;
          }

          &:nth-child(3) {
            position: sticky;
            left: 120px;
          }

          &:nth-child(4) {
            position: sticky;
            left: 227px;
          }

          &:nth-child(5) {
            position: sticky;
            left: 334px;
          }

          &:nth-child(6) {
            position: sticky;
            left: 441px;
          }

          &:nth-child(7) {
            position: sticky;
            left: 548px;
          }

          &:nth-child(8) {
            position: sticky;
            left: 655px;
            border-right: 2px solid #dddddd !important;
          }
        }
      }
    }

    tbody {
      td:nth-child(-n + 8) {
        background-color: #f8f8f8 !important;
        z-index: 1;

        div {
          width: 70px;
        }
      }

      td {
        position: sticky;
        border-bottom: 2px solid #e8e8e8;

        &:nth-child(1) {
          left: 0;
        }

        &:nth-child(2) {
          left: 60px;
        }

        &:nth-child(3) {
          left: 120px;
        }

        &:nth-child(4) {
          left: 227px;
        }

        &:nth-child(5) {
          left: 334px;
        }

        &:nth-child(6) {
          left: 441px;
        }

        &:nth-child(7) {
          left: 548px;
        }

        &:nth-child(8) {
          left: 655px;
          border-right: 2px solid #dddddd !important;
        }

        &:nth-child(n + 7) {
          white-space: nowrap;
        }
      }
    }

    .edit-btn {
      text-align: left;
      font-size: 14px;
      font-weight: 600;
      color: #464646;
      line-height: 1.3;
      text-decoration: none;

      &[disabled] {
        font-weight: normal;
      }

      &:not([disabled]):hover {
        opacity: 0.7;
      }
    }

    .v-data-table-header {
      tr:first-child th {
        height: 30px !important;
        font-weight: 600 !important;
        text-align: center !important;

        &.section {
          border-right: 1px dashed rgba(255, 255, 255, 0.5);
          border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
        }
      }

      th {
        font-size: 14px !important;
        height: 35px !important;
        line-height: 1.3;
        padding-top: 5px;
        padding-bottom: 5px;

        &.section {
          background-color: lighten(#424242, 10%) !important;

          &.last {
            border-right: 1px dashed rgba(255, 255, 255, 0.5);
          }
        }
      }
    }
  }

  &__filter {
    max-width: 250px;
    margin-right: 30px;
  }

  .v-pagination {
    button {
      box-shadow: none !important;
    }
  }
}
</style>
